import { defineStore } from 'pinia';
import { ref } from 'vue';
import { SERVICES } from 'src/enums';
import { $axios } from 'boot/axios';

export const useAppStore = defineStore('app', () => {
  const layoutTitle = ref('');
  const layoutIcon = ref('');

  const layout = ref(null);
  const service = ref(SERVICES.BLOG);
  const backRoute = ref(null);

  async function getLayout() {
    const { data } = (await $axios.get('public/layout')).data;
    layout.value = data;
  }

  return {
    layoutTitle,
    layoutIcon,
    layout,
    getLayout,
    service,
    backRoute,
  };
});
